import $ from "jquery";
import Backbone from "backbone";
import Marionette from "backbone.marionette";
import Cleave from "cleave.js";

import { validatePhone } from "lib/util";

import config from "../config";
import template from "../templates/components/reference.jst";
import modalTemplate from "../templates/components/modal.jst";
import rollbar from "../rollbar";

const AddReferenceView = Marionette.View.extend({
    template,
    ui: {
        button: ".btn-primary",
        jobs: "[name=job]",
        managerName: ".manager-name",
        nameError: ".js-name-error",
        managerNumber: ".manager-number",
        phoneError: ".js-phone-error",
    },
    events: {
        "click @ui.button": "onSubmit",
        "click @ui.jobs": "onJobChange",
        "click .js-show-history": "onShowHistory",
    },
    initialize() {
        this.jobs = this.options.data.jobs.filter((j) => !!j.reference_id);
    },
    serializeData() {
        return {
            jobs: this.jobs,
        };
    },
    onRender() {
        this.setValuesFromJob(0);

        if (this.ui.managerNumber.length) {
            /* eslint-disable no-new */
            new Cleave(this.ui.managerNumber, config.cleave.PHONE_CONFIG);
            /* eslint-enable no-new */
        }
    },
    getData() {
        const index = Number(this.ui.jobs.filter(":checked").val());
        const job = this.jobs[index];
        if (!job) {
            return false;
        }

        const managerName = this.ui.managerName.val().trim();
        const managerNumber = this.ui.managerNumber.val().trim();

        let hasErrors = false;
        if (managerName.length === 0) {
            hasErrors = true;
            this.ui.nameError.show();
        }

        if (!validatePhone(managerNumber)) {
            hasErrors = true;
            this.ui.phoneError.show();
        }

        if (hasErrors) {
            return false;
        }

        return {
            reference_id: job.reference_id,
            manager_name: managerName,
            manager_number: managerNumber,
        };
    },
    setValuesFromJob(index) {
        const job = this.jobs[index] || {};

        this.ui.managerName.val(job.manager_name);
        this.ui.managerNumber.val(job.manager_number);
    },
    onJobChange(event) {
        const $target = $(event.target);
        const index = Number($target.val());

        this.setValuesFromJob(index);
    },
    onSubmit(event) {
        event.preventDefault();

        this.ui.nameError.hide();
        this.ui.phoneError.hide();

        const data = this.getData();
        if (!data) {
            return;
        }

        this.ui.button.loading(true);

        $.ajax({
            data: JSON.stringify(data),
            type: "POST",
            url: "/api/hire/v1/reference/",
            dataType: "json",
            contentType: "application/json",
        })
            .done(() => {
                this.trigger("saved", this.options.data);
            })
            .fail((e) => {
                rollbar.warn("Failed to save references", e);
                this.trigger("finished");
            })
            .always(() => {
                this.ui.button.loading(false);
            });
    },
    onShowHistory() {
        this.trigger("finished");
        Backbone.Radio.channel("profile").trigger("step:show", "STEP_HISTORY");
    },
});

export default Marionette.View.extend({
    el: "#add-reference-modal",
    template: modalTemplate,
    ui: {
        content: ".modal-content",
    },
    showError(msg) {
        this.ui.form.addClass("has-error");
        this.ui.error.text(msg);
    },
    onRender() {
        if (this.options.data) {
            this.showContent(this.options.data);
        } else {
            $.ajax({
                type: "GET",
                url: "/api/hire/v1/profile/",
                dataType: "json",
                contentType: "application/json",
            })
                .done((data) => {
                    this.showContent(data);
                })
                .fail(() => {
                    this.ui.content.text(
                        "We were unable to fetch your profile data. Please try again.",
                    );
                });
        }

        this.$el.addClass("modal-full");
        this.$el.modal({
            closeClass: "icon-close",
            closeText: "&times;",
            fadeDuration: 350,
            fadeDelay: 0,
        });
    },
    showContent(data) {
        this.view = new AddReferenceView({
            el: this.ui.content,
            data,
        });
        this.view.render();
        this.listenTo(this.view, "saved", () => {
            this.ui.content.append(
                '<div class="portal-dialog portal-dialog-text"><h2>Request sent!</h2></div>',
            );
            setTimeout(() => {
                this.finish();
            }, 1500);
        });
        this.listenTo(this.view, "finished", this.finish);
    },
    finish() {
        $.modal.close();
        Backbone.Radio.channel("profile").trigger("reload");
    },
});
